/**
 * This file contains common utilities
 * @returns {string}
 */


/**
 * This function will extract stationCode from url params
 * @returns {string}
 */
export function getStationCode() {
    let params = new URLSearchParams(window.location.search);
    return params.get('stationCode');
}


// WEBPACK FOOTER //
// ./src/network/NetworkUtil.js